module.exports = __webpack_public_path__ + "media/images/packager-9b37eddf.svg";